export var PhotoCaptureAnswerControlType;
(function (PhotoCaptureAnswerControlType) {
    PhotoCaptureAnswerControlType["SCRIPT_QUESTION"] = "SCRIPT_QUESTION";
    PhotoCaptureAnswerControlType["ADD_ATTACHMENT"] = "ADD_ATTACHMENT";
    PhotoCaptureAnswerControlType["YES_NO_VALUE"] = "YES_NO_VALUE";
    PhotoCaptureAnswerControlType["CHOICE_SELECTION"] = "CHOICE_SELECTION";
    PhotoCaptureAnswerControlType["STATIC_SCREEN"] = "STATIC_SCREEN";
})(PhotoCaptureAnswerControlType || (PhotoCaptureAnswerControlType = {}));
//# sourceMappingURL=PhotoCaptureAnswerControlType.js.map